export default __webpack_public_path__ + "static/media/img (3).7b5de631.jpg";